module.exports = __webpack_public_path__ + "static/media/director.bd262198.jpg";